/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import jwtDecode from 'jwt-decode';

export const tryDecodeJwt = (token) => {
  if (typeof token !== 'string' || !token) return null;
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
};

export const getTokenExpirySeconds = (token) => {
  const exp = tryDecodeJwt(token)?.exp;
  return typeof exp === 'number' ? exp : null;
};

export const isTokenExpired = (token, leewaySeconds = 0) => {
  const exp = getTokenExpirySeconds(token);
  return exp === null || exp <= Date.now() / 1000 + leewaySeconds;
};

export const getTokenRoles = (token) => tryDecodeJwt(token)?.realm_access?.roles ?? [];

export const hasAnyRole = (token, roles) =>
  Array.isArray(roles) && roles.length > 0 && getTokenRoles(token).some((r) => roles.includes(r));
